import { render, staticRenderFns } from "./PosMemoPopup.vue?vue&type=template&id=571c4a66&scoped=true&"
import script from "./PosMemoPopup.vue?vue&type=script&lang=js&"
export * from "./PosMemoPopup.vue?vue&type=script&lang=js&"
import style0 from "./PosMemoPopup.vue?vue&type=style&index=0&id=571c4a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571c4a66",
  null
  
)

export default component.exports